(function () {

    "use strict";

    // Routing
    function routingConfiguration($stateProvider) {
        $stateProvider
        .state("workflow", {
            url: "/workflow/:id",
            template: "<sphforms-workflow-detail></sphforms-workflow-detail>"
            }).state("sphformsworkflow", {
            url: "/sphformsworkflow/:id/:sort",
                template: "<sphforms-internal-workflow-detail></sphforms-workflow-detail>"
        });
    }

    routingConfiguration.$inject = ["$stateProvider"];

    angular.module("sphforms.workflow")
        .config(routingConfiguration);

}());